import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsBgGradientModule } from '../../common/pipe/bg-gradient';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsUserQuickAccessModule } from '../../user/quick-access';

import { CoachingNavigationBarComponent } from './component/navigation-bar/navigation-bar.component';
import { TranslationIdMap as CoachingNavigationBarTranslationIdMap } from './component/navigation-bar/navigation-bar.component.i18n';
import { UserComponent } from './component/user/user.component';
import { TranslationIdMap as UserTranslationIdMap } from './component/user/user.component.i18n';

@NgModule({
    declarations: [CoachingNavigationBarComponent, UserComponent],
    imports: [
        CmpsBgGradientModule,
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(CoachingNavigationBarTranslationIdMap),
        CmpsLazyI18nModule.forChild(UserTranslationIdMap),
        CmpsPortalModule,
        CmpsTooltipModule,
        CmpsUserQuickAccessModule,
        CommonModule,
    ],
    exports: [CoachingNavigationBarComponent, UserComponent],
})
export class CmpsInsightWidgetModule {}
